(function () {
  'use strict';

  var ARROW =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-5 w-5 text-kb-ink/30 rf-quiz-option-icon" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';

  var ARROW_BACK =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-4 w-4 rotate-180" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';

  var CHECK =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check h-5 w-5 text-kb-accent rf-quiz-option-icon" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';

  var EXTERNAL =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link h-4 w-4" aria-hidden="true"><path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg>';

  var RESTART =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-ccw h-4 w-4" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>';

  var STEP_KEYS = ['phase', 'challenge', 'preference'];
  var PICK_DELAY_MS = 32;
  var PANEL_FADE_MS = 110;

  function formatPrice(value) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format(value);
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getLandingConfig() {
    var cfg = document.getElementById('recovery-fuel-config');
    return {
      mealShakeUrl: cfg ? cfg.getAttribute('data-meal-shake-url') || '' : '',
    };
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function trackEvent(name, detail) {
    try {
      var payload = detail || {};
      document.dispatchEvent(
        new CustomEvent('rf:' + name, { detail: payload })
      );
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'rf_' + name }, payload));
      }
    } catch (error) {
      /* no-op */
    }
  }

  function initTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var el = event.target.closest('[data-rf-track]');
        if (!el) return;
        trackEvent(el.getAttribute('data-rf-track'), {
          label: el.getAttribute('data-rf-track-label') || '',
          location: el.getAttribute('data-track-location') || '',
          card: el.getAttribute('data-track-card') || '',
          href: el.getAttribute('href') || '',
        });
      },
      true
    );

    if (!('IntersectionObserver' in window)) return;

    var seen = {};

    function observeViews(selector, threshold) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var name = entry.target.getAttribute('data-rf-track');
            if (!name || seen[name]) return;
            seen[name] = true;
            trackEvent(name, { label: 'view' });
            observer.unobserve(entry.target);
          });
        },
        { threshold: threshold }
      );

      document.querySelectorAll(selector).forEach(function (node) {
        observer.observe(node);
      });
    }

    observeViews(
      '[data-rf-track="solution_reveal_view"], [data-rf-track="nutrition_card_view"]',
      0.35
    );
    observeViews('[data-rf-track="nutrition_overview_view"]', 0.5);
  }

  function initHeaderScroll() {
    var header = document.querySelector(
      '.recovery-fuel-landing [data-testid="site-header"]'
    );
    if (!header) return;

    var lastY = window.scrollY || 0;
    var ticking = false;
    var hideAfter = 80;

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var goingDown = y > lastY + 2;
      var goingUp = y < lastY - 2;

      if (y > 12) header.classList.add('rf-header--scrolled');
      else header.classList.remove('rf-header--scrolled');

      if (y <= hideAfter) {
        header.classList.remove('rf-header--hidden');
      } else if (goingDown) {
        header.classList.add('rf-header--hidden');
      } else if (goingUp) {
        header.classList.remove('rf-header--hidden');
      }

      lastY = y;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  function getHeaderOffset() {
    var header = document.querySelector('[data-testid="site-header"]');
    return header ? header.offsetHeight + 8 : 80;
  }

  function scrollToElement(element, focusAfter) {
    if (!element) return;

    var top = element.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });

    if (!focusAfter) return;

    window.setTimeout(
      function () {
        element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: true });
      },
      prefersReducedMotion() ? 0 : 420
    );
  }

  function isTrackingParam(key) {
    var lower = String(key || '').toLowerCase();
    return (
      lower.indexOf('utm_') === 0 ||
      lower === 'gclid' ||
      lower === 'fbclid' ||
      lower === 'msclkid' ||
      lower === 'ttclid' ||
      lower === 'twclid' ||
      lower === 'mc_cid' ||
      lower === 'mc_eid'
    );
  }

  function toProductPath(url) {
    if (!url) return '';

    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function appendUtms(url) {
    if (!url) return url;

    var search = window.location.search;
    if (!search || search === '?') return toProductPath(url);

    try {
      var target = new URL(toProductPath(url), window.location.origin);
      var params = new URLSearchParams(search);
      params.forEach(function (value, key) {
        if (isTrackingParam(key)) target.searchParams.set(key, value);
      });
      return target.pathname + target.search + target.hash;
    } catch (error) {
      return toProductPath(url);
    }
  }

  function bindScrollLinks() {
    var scrollTargets = {
      'quiz-intro': '#quiz-intro',
      'quiz-start': '#rf-quiz-root',
    };

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.recovery-fuel-landing, [data-testid="closing-cta-section"]')) return;

      var scrollTrigger = event.target.closest('[data-rf-scroll]');
      if (scrollTrigger) {
        event.preventDefault();
        var key = scrollTrigger.getAttribute('data-rf-scroll');
        var selector = scrollTargets[key];
        if (!selector) return;
        scrollToElement(document.querySelector(selector), key === 'quiz-start');
        return;
      }

      var mealShakeTrigger = event.target.closest('[data-rf-href="meal-shake"]');
      if (mealShakeTrigger) {
        event.preventDefault();
        var config = getLandingConfig();
        var url = mealShakeTrigger.getAttribute('href') || config.mealShakeUrl;
        if (!url) return;
        window.location.href = appendUtms(url);
      }
    });
  }

  var QUIZ_PRIMARY_BY_ANSWER = {
    eetlust: {
      snel: 'meal-shake-500-gram',
      gevarieerd: 'meal-shake-1-kilo',
      'weinig-gedoe': 'meal-shake-1-kilo',
    },
    eiwit: {
      snel: 'protein-bar-box',
      gevarieerd: 'protein-bar-box',
      'weinig-gedoe': 'meal-shake-1-kilo',
    },
    huidhaar: {
      snel: 'triple-collagen',
      gevarieerd: 'triple-collagen',
      'weinig-gedoe': 'triple-collagen',
    },
    energie: {
      snel: 'menstrual-cycle-balance',
      gevarieerd: 'menstrual-cycle-balance',
      'weinig-gedoe': 'menstrual-cycle-balance',
    },
  };

  function findQuizProduct(result, slug) {
    if (!result || !slug) return null;

    var items = [result.bundle].concat(result.supporting || []);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].slug === slug) return items[i];
    }

    return null;
  }

  function resolvePrimaryProduct(result, answers) {
    var challenge = answers && answers.challenge;
    var preference = answers && answers.preference;
    var slug =
      QUIZ_PRIMARY_BY_ANSWER[challenge] &&
      QUIZ_PRIMARY_BY_ANSWER[challenge][preference];
    var product = findQuizProduct(result, slug);

    if (product) return product;

    var supporting = (result && result.supporting) || [];
    if (supporting.length === 1) return supporting[0];

    if (result && result.bundle && result.bundle.category !== 'bundel') {
      return result.bundle;
    }

    if (supporting.length) return supporting[0];

    return result ? result.bundle : null;
  }

  function getResultProductUrl(product, fallbackUrl) {
    if (product && product.product_url) return toProductPath(product.product_url);
    if (product && product.slug) return '/products/' + product.slug;
    if (fallbackUrl && isShakeProduct(product)) return toProductPath(fallbackUrl);
    return '';
  }

  function isShakeProduct(product) {
    if (!product) return false;
    var slug = String(product.slug || '');
    var category = String(product.category || '');
    return (
      category === 'shake' ||
      slug.indexOf('meal-shake') !== -1 ||
      slug.indexOf('mealshake') !== -1
    );
  }

  function getResultCtaLabel(product) {
    if (!product) return 'Bekijk product';

    var slug = String(product.slug || '');

    if (slug.indexOf('triple-collagen') !== -1 || slug.indexOf('glow-herstel') !== -1) {
      return 'Bekijk Triple Collagen';
    }
    if (slug.indexOf('protein-bar') !== -1 || slug.indexOf('eiwit-spierbehoud') !== -1) {
      return 'Bekijk de Protein Bars';
    }
    if (slug.indexOf('menstrual') !== -1 || slug.indexOf('energie-balans') !== -1) {
      return 'Bekijk Menstrual Cycle Balance';
    }
    if (isShakeProduct(product) || slug.indexOf('makkelijk-compleet') !== -1) {
      return 'Bekijk de Meal Shake';
    }
    if (product.name) return 'Bekijk ' + product.name;

    return 'Bekijk product';
  }

  function bindFaq() {
    document.querySelectorAll('[data-testid^="faq-item-"]').forEach(function (item) {
      var trigger = item.querySelector('button[type="button"]');
      var panel = item.querySelector('[role="region"]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        var next = !open;

        item.setAttribute('data-state', next ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
        trigger.setAttribute('data-state', next ? 'open' : 'closed');
        panel.setAttribute('data-state', next ? 'open' : 'closed');

        if (next) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    });
  }

  function Quiz(root, data, mealShakeUrl) {
    this.root = root;
    this.steps = data.quizSteps;
    this.map = data.quizMap;
    this.mealShakeUrl = mealShakeUrl || '';
    this.answers = { phase: null, challenge: null, preference: null };
    this.stepIndex = 0;
    this.busy = false;
  }

  Quiz.prototype.ensureShell = function () {
    var panel = this.root.querySelector('[data-rf-quiz-panel]');
    var fill = this.root.querySelector('[data-rf-quiz-progress-fill]');

    if (!fill) {
      var track = this.root.querySelector('.rf-quiz-progress-track');
      if (!track) {
        track = document.createElement('div');
        track.className =
          'rf-quiz-progress-track h-1.5 w-full overflow-hidden rounded-full bg-kb-cream';
        this.root.insertBefore(track, this.root.firstChild);
      }
      fill = document.createElement('div');
      fill.className = 'rf-quiz-progress-fill h-full rounded-full bg-kb-accent';
      fill.setAttribute('data-rf-quiz-progress-fill', '');
      fill.style.width = '0%';
      track.appendChild(fill);
    } else if (!fill.classList.contains('rf-quiz-progress-fill')) {
      fill.classList.add('rf-quiz-progress-fill');
    }

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'rf-quiz-panel pt-8';
      panel.setAttribute('data-rf-quiz-panel', '');
      this.root.appendChild(panel);
    } else if (!panel.classList.contains('rf-quiz-panel')) {
      panel.classList.add('rf-quiz-panel');
    }
  };

  Quiz.prototype.getPanel = function () {
    this.ensureShell();
    return this.root.querySelector('[data-rf-quiz-panel]');
  };

  Quiz.prototype.setProgress = function (progress) {
    this.ensureShell();
    var fill = this.root.querySelector('[data-rf-quiz-progress-fill]');
    if (fill) fill.style.width = String(progress) + '%';
  };

  Quiz.prototype.renderProgress = function (progress) {
    return (
      '<div class="rf-quiz-progress-track h-1.5 w-full overflow-hidden rounded-full bg-kb-cream">' +
      '<div class="rf-quiz-progress-fill h-full rounded-full bg-kb-accent" style="width:' +
      progress +
      '%"></div></div>'
    );
  };

  Quiz.prototype.renderOption = function (stepKey, option, index) {
    return (
      '<button type="button" data-rf-quiz-option="' +
      escapeHtml(stepKey) +
      ':' +
      escapeHtml(option.id) +
      '" data-index="' +
      index +
      '" class="rf-quiz-option flex w-full items-center justify-between gap-4 rounded-[1.25rem] border-2 border-kb-ink/10 bg-kb-cream p-5 text-left">' +
      '<span><span class="block font-display text-lg font-semibold text-kb-ink">' +
      escapeHtml(option.title) +
      '</span><span class="mt-1 block text-sm text-kb-ink2">' +
      escapeHtml(option.subtitle) +
      '</span></span>' +
      ARROW +
      '</button>'
    );
  };

  Quiz.prototype.renderStepPanel = function () {
    var step = this.steps[this.stepIndex];
    var stepKey = STEP_KEYS[this.stepIndex];
    var options = step.options
      .map(
        function (option, index) {
          return this.renderOption(stepKey, option, index);
        }.bind(this)
      )
      .join('');
    var back =
      this.stepIndex > 0
        ? '<button type="button" data-rf-quiz-back class="rf-quiz-back mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-kb-ink2 hover:text-kb-ink">' +
          ARROW_BACK +
          ' Vorige</button>'
        : '';

    return (
      '<p class="text-xs font-semibold uppercase tracking-wider text-kb-accent">Vraag ' +
      (this.stepIndex + 1) +
      ' van 3</p>' +
      '<h3 class="mt-2 font-display text-2xl font-semibold tracking-tight text-kb-ink sm:text-3xl">' +
      escapeHtml(step.label) +
      '</h3>' +
      '<div class="mt-6 flex flex-col gap-3" data-rf-quiz-options>' +
      options +
      '</div>' +
      back
    );
  };

  Quiz.prototype.renderStep = function () {
    var step = this.steps[this.stepIndex];
    var panel = this.getPanel();
    panel.className = 'rf-quiz-panel pt-8';
    panel.removeAttribute('data-testid');
    panel.innerHTML = this.renderStepPanel();
    this.setProgress(step.progress);
  };

  Quiz.prototype.getResult = function () {
    var phase = this.answers.phase;
    var key =
      phase +
      ':' +
      this.answers.challenge +
      ':' +
      this.answers.preference;
    var result = this.map[key];
    if (!result && phase === 'orienteer') {
      key =
        'gestopt:' +
        this.answers.challenge +
        ':' +
        this.answers.preference;
      result = this.map[key];
    }
    return result;
  };

  Quiz.prototype.renderResult = function () {
    if (!this.map || !Object.keys(this.map).length) {
      var self = this;
      window.setTimeout(function () {
        self.renderResult();
      }, 40);
      return;
    }

    var result = this.getResult();
    if (!result) {
      var errorPanel = this.getPanel();
      errorPanel.className = 'rf-quiz-panel pt-8';
      errorPanel.innerHTML =
        '<p class="text-sm text-kb-ink2">Er ging iets mis. Probeer het opnieuw.</p>';
      this.setProgress(100);
      return;
    }

    var primaryProduct = resolvePrimaryProduct(result, this.answers) || result.bundle;
    var resultCtaUrl = getResultProductUrl(primaryProduct, this.mealShakeUrl);
    var resultCtaLabel = getResultCtaLabel(primaryProduct);
    var resultCtaAria = resultCtaLabel + ' — ga naar de productpagina';
    var resultProductHref = resultCtaUrl ? appendUtms(resultCtaUrl) : '#';
    var supporting = (result.supporting || [])
      .filter(function (product) {
        return !primaryProduct || product.slug !== primaryProduct.slug;
      })
      .map(function (product) {
        return (
          '<a href="' +
          escapeHtml(appendUtms(product.product_url)) +
          '" rel="noopener noreferrer" data-testid="quiz-support-' +
          escapeHtml(product.slug) +
          '" class="flex items-center gap-3 rounded-[1.25rem] bg-kb-cream p-3 transition-colors hover:bg-kb-butter">' +
          '<img alt="' +
          escapeHtml(product.name) +
          '" class="h-12 w-12 object-contain" src="' +
          escapeHtml(product.image) +
          '">' +
          '<span class="text-sm font-semibold leading-tight text-kb-ink">' +
          escapeHtml(product.name) +
          '</span></a>'
        );
      })
      .join('');

    var panel = this.getPanel();
    panel.className = 'rf-quiz-panel rf-quiz-result pt-8';
    panel.setAttribute('data-testid', 'quiz-result');
    panel.innerHTML =
      '<div class="grid items-center gap-6 sm:grid-cols-[0.85fr_1.15fr]">' +
      '<a href="' +
      escapeHtml(resultProductHref) +
      '" class="block rounded-[1.5rem] bg-kb-butter p-4 transition-opacity hover:opacity-90" data-testid="quiz-result-product" aria-label="' +
      escapeHtml(resultCtaAria) +
      '"><img alt="' +
      escapeHtml(primaryProduct.name) +
      '" class="h-48 w-full object-contain" src="' +
      escapeHtml(primaryProduct.image) +
      '"></a>' +
      '<div><span class="inline-flex items-center gap-1.5 rounded-full bg-kb-ink px-3 py-1 text-xs font-semibold text-white">' +
      CHECK +
      ' Dit kan bij jouw voorkeuren passen</span>' +
      '<h3 class="mt-3 font-display text-2xl font-semibold tracking-tight text-kb-ink">' +
      '<a href="' +
      escapeHtml(resultProductHref) +
      '" class="text-kb-ink transition-colors hover:text-kb-brown">' +
      escapeHtml(primaryProduct.name) +
      '</a></h3>' +
      '<p class="mt-2 text-sm leading-relaxed text-kb-ink2">' +
      escapeHtml(result.reason) +
      '</p>' +
      '<p class="mt-4 font-display text-2xl font-semibold text-kb-ink">' +
      formatPrice(primaryProduct.price) +
      '</p></div></div>' +
      '<div class="mt-6 flex flex-col gap-3 sm:flex-row">' +
      '<a href="' +
      escapeHtml(resultProductHref) +
      '" data-testid="quiz-result-cta" data-rf-track="pdp_click" data-rf-track-label="quiz_result" aria-label="' +
      escapeHtml(resultCtaAria) +
      '" class="rf-quiz-result-cta group inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-kb-ink px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-black">' +
      escapeHtml(resultCtaLabel) +
      EXTERNAL +
      '</a>' +
      '<button type="button" data-rf-quiz-restart class="rf-quiz-restart inline-flex items-center justify-center gap-2 rounded-full border border-kb-ink/15 bg-white px-7 py-3.5 text-sm font-semibold text-kb-ink transition-all hover:bg-kb-butter">' +
      RESTART +
      ' Opnieuw</button></div>' +
      (supporting
        ? '<div class="mt-8 border-t border-kb-ink/10 pt-6"><p class="text-sm font-semibold text-kb-ink2">Vaak ook fijn hierbij</p><div class="mt-4 grid grid-cols-2 gap-3">' +
          supporting +
          '</div></div>'
        : '') +
      '';
    this.setProgress(100);
    trackEvent('quiz_complete', {
      phase: this.answers.phase,
      challenge: this.answers.challenge,
      preference: this.answers.preference,
      product: primaryProduct && primaryProduct.slug,
    });
  };

  Quiz.prototype.transition = function (renderFn) {
    var panel = this.getPanel();
    if (!panel || prefersReducedMotion()) {
      renderFn();
      return;
    }

    var outClass = 'rf-quiz-panel--out';
    var finished = false;

    function revealNext() {
      if (finished) return;
      finished = true;
      panel.classList.remove(outClass);
      renderFn();
      panel.classList.add('rf-quiz-panel--pre-in');
      requestAnimationFrame(function () {
        panel.classList.add('rf-quiz-panel--in');
        window.setTimeout(function () {
          panel.classList.remove('rf-quiz-panel--pre-in', 'rf-quiz-panel--in');
        }, PANEL_FADE_MS);
      });
    }

    function onFadeOut(event) {
      if (event.target !== panel || event.propertyName !== 'opacity') return;
      panel.removeEventListener('transitionend', onFadeOut);
      revealNext();
    }

    panel.addEventListener('transitionend', onFadeOut);
    panel.classList.add(outClass);
    window.setTimeout(revealNext, PANEL_FADE_MS + 40);
  };

  Quiz.prototype.pick = function (stepKey, value, button) {
    if (this.busy) return;
    this.busy = true;

    var optionsWrap = this.root.querySelector('[data-rf-quiz-options]');
    if (button) {
      button.classList.add('rf-quiz-option--selected');
      button.disabled = true;
      if (optionsWrap) optionsWrap.classList.add('rf-quiz-options--chosen');

      var icon = button.querySelector('.rf-quiz-option-icon');
      if (icon) icon.outerHTML = CHECK;
    }

    var self = this;
    var pickDelay = prefersReducedMotion() ? 0 : PICK_DELAY_MS;
    var advance = function () {
      self.answers[stepKey] = value;
      if (self.stepIndex < self.steps.length - 1) {
        self.stepIndex += 1;
        self.setProgress(self.steps[self.stepIndex].progress);
        self.transition(function () {
          self.renderStep();
          self.busy = false;
        });
        return;
      }

      self.setProgress(100);
      self.transition(function () {
        self.renderResult();
        self.busy = false;
      });
    };

    if (pickDelay) {
      window.setTimeout(advance, pickDelay);
    } else {
      advance();
    }
  };

  Quiz.prototype.back = function () {
    if (this.busy || this.stepIndex === 0) return;
    this.busy = true;

    var currentKey = STEP_KEYS[this.stepIndex];
    this.answers[currentKey] = null;
    this.stepIndex -= 1;

    var self = this;
    this.setProgress(this.steps[this.stepIndex].progress);
    this.transition(function () {
      self.renderStep();
      self.busy = false;
    });
  };

  Quiz.prototype.restart = function () {
    if (this.busy) return;
    this.busy = true;

    this.answers = { phase: null, challenge: null, preference: null };
    this.stepIndex = 0;

    var self = this;
    this.setProgress(this.steps[0].progress);
    this.transition(function () {
      self.renderStep();
      self.busy = false;
    });
  };

  Quiz.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-rf-quiz-option]');
      if (option) {
        event.preventDefault();
        var parts = option.getAttribute('data-rf-quiz-option').split(':');
        self.pick(parts[0], parts[1], option);
        return;
      }
      if (event.target.closest('[data-rf-quiz-back]')) {
        event.preventDefault();
        self.back();
        return;
      }
      if (event.target.closest('[data-rf-quiz-restart]')) {
        event.preventDefault();
        self.restart();
      }
    });
  };

  function initQuiz(dataUrl, stepsUrl) {
    var root = document.getElementById('rf-quiz-root');
    if (!root) return;

    var config = getLandingConfig();
    var quiz = null;

    function boot(data) {
      if (quiz) {
        if (data.quizSteps) quiz.steps = data.quizSteps;
        if (data.quizMap) quiz.map = data.quizMap;
        return;
      }

      quiz = new Quiz(root, data, config.mealShakeUrl);
      quiz.bind();
      quiz.renderStep();
    }

    function showLoadError() {
      if (quiz) return;
      root.innerHTML =
        '<p class="pt-8 text-sm text-kb-ink2">Quiz kon niet geladen worden.</p>';
    }

    if (stepsUrl) {
      fetch(stepsUrl)
        .then(function (res) {
          return res.json();
        })
        .then(function (stepsData) {
          boot({ quizSteps: stepsData.quizSteps, quizMap: {} });
          return fetch(dataUrl).then(function (res) {
            return res.json();
          });
        })
        .then(function (fullData) {
          boot({ quizMap: fullData.quizMap });
        })
        .catch(function () {
          fetch(dataUrl)
            .then(function (res) {
              return res.json();
            })
            .then(boot)
            .catch(showLoadError);
        });
      return;
    }

    fetch(dataUrl)
      .then(function (res) {
        return res.json();
      })
      .then(boot)
      .catch(showLoadError);
  }

  function initHeroPouches() {
    var fan = document.querySelector('[data-testid="hero-pouch-fan"]');
    if (!fan) return;

    var imgs = fan.querySelectorAll('.rf-hero-pouch');
    if (!imgs.length) {
      fan.classList.add('rf-hero-pouches-ready');
      return;
    }

    var pending = 0;

    function markReady() {
      if (fan.classList.contains('rf-hero-pouches-ready')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fan.classList.add('rf-hero-pouches-ready');
        });
      });
    }

    imgs.forEach(function (img, index) {
      if (index === 0) img.setAttribute('fetchpriority', 'high');
      else img.removeAttribute('fetchpriority');

      if (img.complete) {
        if (img.naturalWidth > 0) return;
        pending += 1;
        onReady();
        return;
      }

      pending += 1;
      img.addEventListener('load', onReady, { once: true });
      img.addEventListener('error', onReady, { once: true });
    });

    function onReady() {
      pending -= 1;
      if (pending <= 0) markReady();
    }

    if (pending === 0) markReady();
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindScrollLinks();
    bindFaq();
    initHeaderScroll();
    initHeroPouches();
    initTracking();

    var dataScript = document.getElementById('recovery-fuel-config');
    if (dataScript) {
      initQuiz(
        dataScript.getAttribute('data-url'),
        dataScript.getAttribute('data-steps-url')
      );
    }
  });
})();
